import $ from "jquery"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as rt from "../../../routes/routes"
import * as ses from "../../../configurations/session/sessioncomplete"
import baseurl from "../../../configurations/baseurl/baseurl"


export const actions = {

    Storeroles({ commit }, roleId) {
        commit('UPDATE_USER_ROLE', roleId)
    },

    Storerolemodules({ state, commit }, rmoduleId, ) {
        commit('UPDATE_USER_ROLE_MODULES', rmoduleId)
        commit('STORE_MODULE_ID', rmoduleId)
        
        let data = {
            userid: $('.userid').val(),
            roleModuleId: rmoduleId
        }
        $('.modulespermissionLoader').show()
        baseurl

            .post(rt.modulePermissions, data)
            .then(res => {
                $('.modulespermissionLoader').hide()
                if (res.data.code === 200) {
                    commit('STORE_ROLE_MODULES_PERMISSIONS', res.data.modulePermissions)
                } else if (res.data.code === 404) {
                    ers.errorLoadingModulePermissions()
                }else if(res.data.code === 405){
                    ers.noPermissionToCreate()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }
            })
    },

    asignUserRoleModules({ state }) {

        if (state.userroles.length > 1) {
            ers.errorOnMaximumRoles()
        } else if (state.userroles.length === 0) {
            ers.userRolesRequired()
        } else {

            let roleModules = {
                userid: $('.userid').val(),
                roles: state.userroles,
                modules: state.rolemodules
            }
            $('.asigninUserRoleModulesLoader').show()
            $('.asignRoleModules').hide()

            baseurl
                .post(rt.asignuserRoleModules, roleModules)
                .then(res => {

                    $('.asigninUserRoleModulesLoader').hide()
                    $('.asignRoleModules').show()
                    if (res.data.code === 200) {
                        suc.asignUserRoleModelSuccess()
                    } else if (res.data.code === 404) {
                        ers.errorAsignUserRoleModule()
                    }else if(res.data.code === 405){
                        ers.noPermissionToCreate()
                    } else if (res.data.code === 506) {
                        ses.sessionComplete()
                    }

                })
        }
    },

    StorerolemodulesPermissions({ commit }, permId) {

        commit('UPDATE_ROLE_MODULES_PERMISSIONS', permId)
    },

    asignModulePermissions({ state }) {

        if (state.moduleId.length === 0) {
            ers.errorModuleNotSelected()
        } else {
            
            let ModulesPermissions = {
                userid: $('.userid').val(),
                moduleid: state.moduleId,
                permissions: state.modulePermissions
            }
            $('.asignModuleLoader').show()
            $('.asignPermissionsBtns').hide()
            baseurl
                .post(rt.asignModulePermissions, ModulesPermissions)
                .then(res => {
                    $('.asignModuleLoader').hide()
                    $('.asignPermissionsBtns').show()
                    if (res.data.code === 200 && res.data.permissions.length === 0) {
                        suc.removedRoleModulePermissionsSuccess()
                    } else if (res.data.code === 200 && res.data.permissions.length >= 1) {
                        suc.asignRoleModulePermissionsSuccess()
                    } else if (res.data.code === 404) {
                        ers.errorAsigningRoleModulePermissions()
                    }else if(res.data.code === 405){
                        ers.noPermissionToCreate()
                    } else if (res.data.code === 406) {
                        ers.errorRoleModuleNotAsigned()
                    } else if (res.data.code === 506) {
                        ses.sessionComplete()
                    }

                })
        }
    }
}

export default actions


// WEBPACK FOOTER //
// ./src/vuex/modules/userroles/actions.js